// Generic, one-shot "where should the user land after logging in" signal. Set from a `?next=`
// query param on the /login URL (e.g. an emailed deep link) and consumed exactly once by
// whichever shell mounts right after login - sessionStorage survives the /login -> role-default
// navigation within the same tab, which a URL param alone would not, since 3 of the 5 shells
// have no distinct URL for some destinations (Validation being the first example).
//
// Deliberately not holiday/Validation-specific at this layer: `next` is an opaque string, and
// any future notification type can introduce a new value here without touching this module -
// each shell decides for itself which values it recognizes and what to do with them.
const KEY = 'enko_post_login_next';

export function setPostLoginNext(value) {
  if (value) sessionStorage.setItem(KEY, value);
}

// Reads and clears the signal in one step, so a value that isn't acted on (e.g. the logged-in
// user doesn't qualify for the requested destination) is not left to be silently consumed by a
// later, unrelated login in the same tab.
export function consumePostLoginNext() {
  const value = sessionStorage.getItem(KEY);
  if (value) sessionStorage.removeItem(KEY);
  return value;
}

// ATTESTDEEPLINK: read WITHOUT clearing. Some destinations (attestations) live inside the embedded
// "My Profile" EmployeeView, which the outer shell (Dashboard/ComplianceView/StaffView) has to
// mount FIRST by switching to its My Profile section. That outer shell must route on the signal but
// leave it intact so EmployeeView can then consume it (once) and open the right tab. Using consume
// in the outer shell would clear it before EmployeeView ever sees it.
export function peekPostLoginNext() {
  return sessionStorage.getItem(KEY);
}

// FPMGRMAIL: the F&P assessment the manager's email names, opened by the Validation page once.
const FP_KEY = 'enko_open_fp_assessment';

export function setOpenFpAssessment(id) {
  if (id) sessionStorage.setItem(FP_KEY, id);
}

export function consumeOpenFpAssessment() {
  const value = sessionStorage.getItem(FP_KEY);
  if (value) sessionStorage.removeItem(FP_KEY);
  return value;
}
